import * as React from 'react';

import { Badge } from '~shared/components/Badge';
import { ModalMenuBackButton } from '~teacher/components/ModalMenu';

export interface Props {
  title?: string;
  description: string;
  shouldShowProBadge: boolean;
  shouldHaveSpaceBeforeTitle?: boolean;
}
export const ReportOptionHeader: React.FC<Props> = ({
  title,
  description,
  shouldShowProBadge = false,
  shouldHaveSpaceBeforeTitle = false,
}: React.PropsWithChildren<Props>) => (
  <header>
    <div className="flex md:hidden -mt-2 -ml-2">
      <ModalMenuBackButton />
    </div>
    <div className="flex items-center pt-2 sm:pt-0">
      <h3 className={`${shouldHaveSpaceBeforeTitle ? 'pl-16' : ''} m-0 font-display font-700 md:font-500 text-md text-blue-900 leading-8`}>
        {title}
      </h3>
      {shouldShowProBadge && (
        <div className="pl-2">
          <Badge>Pro</Badge>
        </div>
      )}
    </div>
    <p className="m-0 pt-6 pr-6 text-base text-blue-600 leading-8">
      {description}
    </p>
  </header>
);
